import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import CarDetail from "@/pages/CarDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import DealerRegister from "@/pages/DealerRegister";
import DealerLogin from "@/pages/DealerLogin";
import DealerDashboard from "@/pages/DealerDashboard";
import SubmitCar from "@/pages/SubmitCar";

function App() {
  return (
    <div className="min-h-screen bg-[#030303]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/car/:id" element={<CarDetail />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/dealer-register" element={<DealerRegister />} />
          <Route path="/dealer-login" element={<DealerLogin />} />
          <Route path="/dealer/dashboard" element={<DealerDashboard />} />
          <Route path="/submit-car" element={<SubmitCar />} />
          {/* Legacy buyer routes → redirect to dealer-login (B2B-only Phase 7) */}
          <Route path="/account" element={<Navigate to="/dealer-login" replace />} />
          <Route path="/checkout/success" element={<Navigate to="/dealer-login" replace />} />
          <Route path="/reklamacio" element={<Navigate to="/dealer-login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
